import { MASTER_CODE_REQUEST, LOGOUT } from "../actionTypes";

const Storage = (userData) => {
  localStorage.setItem(
    "auth",
    JSON.stringify(Object.keys(userData).length > 0 ? userData : [])
  );
};

export const saveAuthUser = (userData) => {
  Storage(userData);
};

const storage = localStorage.getItem("auth")
  ? JSON.parse(localStorage.getItem("auth"))
  : [];

const initialState = {
  isAuth: Object.keys(storage).length > 0 ? true : false,
  user: storage,
  ...saveAuthUser(storage),
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case MASTER_CODE_REQUEST:
      return {
        ...state,
        isAuth: Object.keys(action.payload).length > 0 ? true : false,
        user: action.payload,
        ...saveAuthUser(action.payload),
      };
    case LOGOUT:
      return {
        ...state,
        isAuth: false,
        user: {},
      };
    default:
      return state;
  }
}
